// GENERATED FILE, PLEASE DO NOT EDIT
var BorderFocus = '#4969f5';
var BreadcrumbText = '#191919';
var BreadcrumbTextHovered = '#191919';
var BreadcrumbTextPressed = '#494949';
var BreadcrumbTextDisabled = '#B2B2B2';
var ButtonFlatPrimaryForeground = '#00838A';
var ButtonFlatPrimaryForegroundHovered = '#00838A';
var ButtonFlatPrimaryForegroundPressed = '#00838A';
var ButtonLinkForeground = '#4969f5';
var ButtonLinkForegroundHovered = '#2a4de4';
var ButtonLinkForegroundPressed = '#6c87fb';
var ButtonPrimaryBackground = '#00838A';
var ButtonPrimaryBackgroundHovered = '#00666D';
var ButtonPrimaryBackgroundPressed = '#00494E';
var ButtonSecondaryBackground = '#ECFCFC';
var ButtonSecondaryBackgroundHovered = '#D7F5F5';
var ButtonSecondaryBackgroundPressed = '#B6E9EA';
var ButtonSecondaryForeground = '#00838A';
var ButtonSecondaryForegroundHovered = '#00666D';
var ButtonSecondaryForegroundPressed = '#00666D';
var ButtonTertiaryToggleBackground = '#ffffff';
var ButtonTertiaryToggleBackgroundDisabled = '#F7F7F7';
var ButtonTertiaryToggleBackgroundHovered = '#F7F7F7';
var ButtonTertiaryToggleBackgroundOff = '#E7E7E7';
var ButtonTertiaryToggleBackgroundOffDisabled = '#E7E7E7';
var ButtonTertiaryToggleBackgroundOffHovered = '#D6D6D6';
var ButtonTertiaryToggleBackgroundOffPressed = '#D6D6D6';
var ButtonTertiaryToggleBackgroundPressed = '#E7E7E7';
var ButtonTertiaryToggleBorderOff = '#E7E7E7';
var ButtonTertiaryToggleBorderOffHovered = '#D6D6D6';
var ButtonTertiaryToggleBorderOffPressed = '#D6D6D6';
var ButtonTertiaryToggleBorderOffDisabled = '#E7E7E7';
var ButtonTertiaryToggleBorderOn = '#E7E7E7';
var ButtonTertiaryToggleBorderOnHovered = '#E7E7E7';
var ButtonTertiaryToggleBorderOnPressed = '#E7E7E7';
var ButtonTertiaryToggleBorderOnDisabled = '#E7E7E7';
var ButtonTertiaryToggleForeground = '#191919';
var ButtonTertiaryToggleForegroundHovered = '#191919';
var ButtonTertiaryToggleForegroundPressed = '#191919';
var ButtonTertiaryToggleForegroundOff = '#494949';
var ButtonTertiaryToggleForegroundOffDisabled = '#9F9F9F';
var ButtonTertiaryToggleForegroundOffHovered = '#494949';
var ButtonTertiaryToggleForegroundOffPressed = '#494949';
var ButtonTertiaryToggleGroupBackgroundOff = '#E7E7E7';
var ButtonTertiaryToggleGroupBackgroundOffHovered = '#D6D6D6';
var ButtonTertiaryToggleGroupBackgroundOffPressed = '#D6D6D6';
var ButtonTertiaryToggleGroupBackgroundOffDisabled = '#E7E7E7';
var ButtonTertiaryToggleGroupBorderOff = '#E7E7E7';
var ButtonTertiaryToggleGroupBorderOffHovered = '#D6D6D6';
var ButtonTertiaryToggleGroupBorderOffPressed = '#D6D6D6';
var ButtonTertiaryToggleGroupBorderOffDisabled = '#E7E7E7';
var ButtonTertiaryToggleGroupForegroundOff = '#494949';
var ButtonTertiaryToggleGroupForegroundOffHovered = '#494949';
var ButtonTertiaryToggleGroupForegroundOffPressed = '#494949';
var ButtonTertiaryToggleGroupForegroundOffDisabled = '#9F9F9F';
var ButtonTertiaryToggleGroupBackgroundOn = '#ffffff';
var ButtonTertiaryToggleGroupBackgroundOnHovered = '#F7F7F7';
var ButtonTertiaryToggleGroupBackgroundOnPressed = '#E7E7E7';
var ButtonTertiaryToggleGroupBackgroundOnDisabled = '#F7F7F7';
var ButtonTertiaryToggleGroupBorderOn = '#E7E7E7';
var ButtonTertiaryToggleGroupBorderOnHovered = '#E7E7E7';
var ButtonTertiaryToggleGroupBorderOnPressed = '#E7E7E7';
var ButtonTertiaryToggleGroupBorderOnDisabled = '#E7E7E7';
var ButtonTertiaryToggleGroupForegroundOn = '#191919';
var ButtonTertiaryToggleGroupForegroundOnHovered = '#191919';
var ButtonTertiaryToggleGroupForegroundOnPressed = '#191919';
var ButtonTertiaryToggleGroupForegroundOnDisabled = '#9F9F9F';
var ButtonFloatingToggleGroupBackgroundColorOff = '#E7E7E7';
var ButtonTabForegroundOnDefault = '#00838A';
var ButtonTabForegroundOnHovered = '#00838A';
var ButtonTabForegroundOnPressed = '#00838A';
var DatePickerDateSelectedBackground = '#00838A';
var DatePickerDateSelectedBackgroundHovered = '#00666D';
var DatePickerDateSelectedBackgroundPressed = '#00494E';
var DatePickerRangeSelectedBackground = '#D7F5F5';
var DatePickerRangeSelectedBackgroundHovered = '#B6E9EA';
var DatePickerRangeSelectedBackgroundPressed = '#8BD8DA';
var DatePickerTodayBorderSelected = '#191919';
var DatePickerDateUnselectedIndicatorPrimary = '#00838A';
var DatePickerDateSelectedIndicatorPrimary = '#B6E9EA';
var DatePickerRangeSelectedIndicatorPrimary = '#00666D';
var FieldsBackgroundActive = '#ffffff';
var FieldsBackgroundInactive = '#ffffff';
var FieldsBorderActive = '#4969f5';
var FieldsBorderInactive = '#D6D6D6';
var ListCellIconToggledOn = '#00838A';
var ListCellIconToggledOff = '#8B8B8B';
var LoadingDefault = '#00838A';
var PaginationNumberedNavigationBackground = '#ffffff';
var PaginationNumberedNavigationBackgroundDisabled = '#ffffff';
var PaginationNumberedNavigationBorder = '#ffffff';
var PaginationNumberedNavigationBorderDisabled = '#ffffff';
var PaginationNumberedNavigationForeground = '#191919';
var PaginationNumberedSelectedBackground = '#E7E7E7';
var PaginationNumberedSelectedBackgroundDisabled = '#F7F7F7';
var PaginationNumberedSelectedBackgroundHovered = '#D6D6D6';
var PaginationNumberedSelectedBackgroundPressed = '#C4C4C4';
var PaginationNumberedSelectedBorder = '#E7E7E7';
var PaginationNumberedSelectedBorderDisabled = '#F7F7F7';
var PaginationNumberedSelectedBorderHovered = '#D6D6D6';
var PaginationNumberedSelectedBorderPressed = '#C4C4C4';
var PaginationNumberedSelectedForeground = '#191919';
var PaginationNumberedSelectedForegroundDisabled = '#B2B2B2';
var PaginationNumberedSelectedForegroundHovered = '#191919';
var PaginationNumberedSelectedForegroundPressed = '#191919';
var PaginationNumberedUnselectedBackground = '#ffffff';
var PaginationNumberedUnselectedBackgroundDisabled = '#ffffff';
var PaginationNumberedUnselectedBackgroundHovered = '#F7F7F7';
var PaginationNumberedUnselectedBackgroundPressed = '#F7F7F7';
var PaginationNumberedUnselectedBorder = '#ffffff';
var PaginationNumberedUnselectedBorderDisabled = '#ffffff';
var PaginationNumberedUnselectedBorderHovered = '#F7F7F7';
var PaginationNumberedUnselectedBorderPressed = '#F7F7F7';
var PaginationSelectedPrimary = '#00838A';
var SwitchBackgroundOn = '#00838A';
var SwitchBorderOn = '#00838A';
var TableHeaderCellBackground = '#F7F7F7';
var TextAccentedPrimary = '#00838A';
var TextAccentedSecondary = '#4969f5';
var TextAction = '#00838A';
var TextCallout = '#00838A';
var TextLink = '#00838A';
var TextSecondaryOnDark = '#C4C4C4';
var TextSelected = '#00838A';
var ToggleBackgroundOn = '#00838A';
var ToggleBorderOn = '#00838A';
var ToggleBorderOff = '#8B8B8B';
var ToggleBorderOffDisabled = '#C4C4C4';
var ColorSemanticsAll = {
  BorderFocus: BorderFocus,
  BreadcrumbText: BreadcrumbText,
  BreadcrumbTextDisabled: BreadcrumbTextDisabled,
  BreadcrumbTextHovered: BreadcrumbTextHovered,
  BreadcrumbTextPressed: BreadcrumbTextPressed,
  ButtonFlatPrimaryForeground: ButtonFlatPrimaryForeground,
  ButtonFlatPrimaryForegroundHovered: ButtonFlatPrimaryForegroundHovered,
  ButtonFlatPrimaryForegroundPressed: ButtonFlatPrimaryForegroundPressed,
  ButtonFloatingToggleGroupBackgroundColorOff: ButtonFloatingToggleGroupBackgroundColorOff,
  ButtonLinkForeground: ButtonLinkForeground,
  ButtonLinkForegroundHovered: ButtonLinkForegroundHovered,
  ButtonLinkForegroundPressed: ButtonLinkForegroundPressed,
  ButtonPrimaryBackground: ButtonPrimaryBackground,
  ButtonPrimaryBackgroundHovered: ButtonPrimaryBackgroundHovered,
  ButtonPrimaryBackgroundPressed: ButtonPrimaryBackgroundPressed,
  ButtonSecondaryBackground: ButtonSecondaryBackground,
  ButtonSecondaryBackgroundHovered: ButtonSecondaryBackgroundHovered,
  ButtonSecondaryBackgroundPressed: ButtonSecondaryBackgroundPressed,
  ButtonSecondaryForeground: ButtonSecondaryForeground,
  ButtonSecondaryForegroundHovered: ButtonSecondaryForegroundHovered,
  ButtonSecondaryForegroundPressed: ButtonSecondaryForegroundPressed,
  ButtonTabForegroundOnDefault: ButtonTabForegroundOnDefault,
  ButtonTabForegroundOnHovered: ButtonTabForegroundOnHovered,
  ButtonTabForegroundOnPressed: ButtonTabForegroundOnPressed,
  ButtonTertiaryToggleBackground: ButtonTertiaryToggleBackground,
  ButtonTertiaryToggleBackgroundDisabled: ButtonTertiaryToggleBackgroundDisabled,
  ButtonTertiaryToggleBackgroundHovered: ButtonTertiaryToggleBackgroundHovered,
  ButtonTertiaryToggleBackgroundOff: ButtonTertiaryToggleBackgroundOff,
  ButtonTertiaryToggleBackgroundOffDisabled: ButtonTertiaryToggleBackgroundOffDisabled,
  ButtonTertiaryToggleBackgroundOffHovered: ButtonTertiaryToggleBackgroundOffHovered,
  ButtonTertiaryToggleBackgroundOffPressed: ButtonTertiaryToggleBackgroundOffPressed,
  ButtonTertiaryToggleBackgroundPressed: ButtonTertiaryToggleBackgroundPressed,
  ButtonTertiaryToggleBorderOff: ButtonTertiaryToggleBorderOff,
  ButtonTertiaryToggleBorderOffDisabled: ButtonTertiaryToggleBorderOffDisabled,
  ButtonTertiaryToggleBorderOffHovered: ButtonTertiaryToggleBorderOffHovered,
  ButtonTertiaryToggleBorderOffPressed: ButtonTertiaryToggleBorderOffPressed,
  ButtonTertiaryToggleBorderOn: ButtonTertiaryToggleBorderOn,
  ButtonTertiaryToggleBorderOnDisabled: ButtonTertiaryToggleBorderOnDisabled,
  ButtonTertiaryToggleBorderOnHovered: ButtonTertiaryToggleBorderOnHovered,
  ButtonTertiaryToggleBorderOnPressed: ButtonTertiaryToggleBorderOnPressed,
  ButtonTertiaryToggleForeground: ButtonTertiaryToggleForeground,
  ButtonTertiaryToggleForegroundHovered: ButtonTertiaryToggleForegroundHovered,
  ButtonTertiaryToggleForegroundOff: ButtonTertiaryToggleForegroundOff,
  ButtonTertiaryToggleForegroundOffDisabled: ButtonTertiaryToggleForegroundOffDisabled,
  ButtonTertiaryToggleForegroundOffHovered: ButtonTertiaryToggleForegroundOffHovered,
  ButtonTertiaryToggleForegroundOffPressed: ButtonTertiaryToggleForegroundOffPressed,
  ButtonTertiaryToggleForegroundPressed: ButtonTertiaryToggleForegroundPressed,
  ButtonTertiaryToggleGroupBackgroundOff: ButtonTertiaryToggleGroupBackgroundOff,
  ButtonTertiaryToggleGroupBackgroundOffDisabled: ButtonTertiaryToggleGroupBackgroundOffDisabled,
  ButtonTertiaryToggleGroupBackgroundOffHovered: ButtonTertiaryToggleGroupBackgroundOffHovered,
  ButtonTertiaryToggleGroupBackgroundOffPressed: ButtonTertiaryToggleGroupBackgroundOffPressed,
  ButtonTertiaryToggleGroupBackgroundOn: ButtonTertiaryToggleGroupBackgroundOn,
  ButtonTertiaryToggleGroupBackgroundOnDisabled: ButtonTertiaryToggleGroupBackgroundOnDisabled,
  ButtonTertiaryToggleGroupBackgroundOnHovered: ButtonTertiaryToggleGroupBackgroundOnHovered,
  ButtonTertiaryToggleGroupBackgroundOnPressed: ButtonTertiaryToggleGroupBackgroundOnPressed,
  ButtonTertiaryToggleGroupBorderOff: ButtonTertiaryToggleGroupBorderOff,
  ButtonTertiaryToggleGroupBorderOffDisabled: ButtonTertiaryToggleGroupBorderOffDisabled,
  ButtonTertiaryToggleGroupBorderOffHovered: ButtonTertiaryToggleGroupBorderOffHovered,
  ButtonTertiaryToggleGroupBorderOffPressed: ButtonTertiaryToggleGroupBorderOffPressed,
  ButtonTertiaryToggleGroupBorderOn: ButtonTertiaryToggleGroupBorderOn,
  ButtonTertiaryToggleGroupBorderOnDisabled: ButtonTertiaryToggleGroupBorderOnDisabled,
  ButtonTertiaryToggleGroupBorderOnHovered: ButtonTertiaryToggleGroupBorderOnHovered,
  ButtonTertiaryToggleGroupBorderOnPressed: ButtonTertiaryToggleGroupBorderOnPressed,
  ButtonTertiaryToggleGroupForegroundOff: ButtonTertiaryToggleGroupForegroundOff,
  ButtonTertiaryToggleGroupForegroundOffDisabled: ButtonTertiaryToggleGroupForegroundOffDisabled,
  ButtonTertiaryToggleGroupForegroundOffHovered: ButtonTertiaryToggleGroupForegroundOffHovered,
  ButtonTertiaryToggleGroupForegroundOffPressed: ButtonTertiaryToggleGroupForegroundOffPressed,
  ButtonTertiaryToggleGroupForegroundOn: ButtonTertiaryToggleGroupForegroundOn,
  ButtonTertiaryToggleGroupForegroundOnDisabled: ButtonTertiaryToggleGroupForegroundOnDisabled,
  ButtonTertiaryToggleGroupForegroundOnHovered: ButtonTertiaryToggleGroupForegroundOnHovered,
  ButtonTertiaryToggleGroupForegroundOnPressed: ButtonTertiaryToggleGroupForegroundOnPressed,
  DatePickerDateSelectedBackground: DatePickerDateSelectedBackground,
  DatePickerDateSelectedBackgroundHovered: DatePickerDateSelectedBackgroundHovered,
  DatePickerDateSelectedBackgroundPressed: DatePickerDateSelectedBackgroundPressed,
  DatePickerDateSelectedIndicatorPrimary: DatePickerDateSelectedIndicatorPrimary,
  DatePickerDateUnselectedIndicatorPrimary: DatePickerDateUnselectedIndicatorPrimary,
  DatePickerRangeSelectedBackground: DatePickerRangeSelectedBackground,
  DatePickerRangeSelectedBackgroundHovered: DatePickerRangeSelectedBackgroundHovered,
  DatePickerRangeSelectedBackgroundPressed: DatePickerRangeSelectedBackgroundPressed,
  DatePickerRangeSelectedIndicatorPrimary: DatePickerRangeSelectedIndicatorPrimary,
  DatePickerTodayBorderSelected: DatePickerTodayBorderSelected,
  FieldsBackgroundActive: FieldsBackgroundActive,
  FieldsBackgroundInactive: FieldsBackgroundInactive,
  FieldsBorderActive: FieldsBorderActive,
  FieldsBorderInactive: FieldsBorderInactive,
  ListCellIconToggledOff: ListCellIconToggledOff,
  ListCellIconToggledOn: ListCellIconToggledOn,
  LoadingDefault: LoadingDefault,
  PaginationNumberedNavigationBackground: PaginationNumberedNavigationBackground,
  PaginationNumberedNavigationBackgroundDisabled: PaginationNumberedNavigationBackgroundDisabled,
  PaginationNumberedNavigationBorder: PaginationNumberedNavigationBorder,
  PaginationNumberedNavigationBorderDisabled: PaginationNumberedNavigationBorderDisabled,
  PaginationNumberedNavigationForeground: PaginationNumberedNavigationForeground,
  PaginationNumberedSelectedBackground: PaginationNumberedSelectedBackground,
  PaginationNumberedSelectedBackgroundDisabled: PaginationNumberedSelectedBackgroundDisabled,
  PaginationNumberedSelectedBackgroundHovered: PaginationNumberedSelectedBackgroundHovered,
  PaginationNumberedSelectedBackgroundPressed: PaginationNumberedSelectedBackgroundPressed,
  PaginationNumberedSelectedBorder: PaginationNumberedSelectedBorder,
  PaginationNumberedSelectedBorderDisabled: PaginationNumberedSelectedBorderDisabled,
  PaginationNumberedSelectedBorderHovered: PaginationNumberedSelectedBorderHovered,
  PaginationNumberedSelectedBorderPressed: PaginationNumberedSelectedBorderPressed,
  PaginationNumberedSelectedForeground: PaginationNumberedSelectedForeground,
  PaginationNumberedSelectedForegroundDisabled: PaginationNumberedSelectedForegroundDisabled,
  PaginationNumberedSelectedForegroundHovered: PaginationNumberedSelectedForegroundHovered,
  PaginationNumberedSelectedForegroundPressed: PaginationNumberedSelectedForegroundPressed,
  PaginationNumberedUnselectedBackground: PaginationNumberedUnselectedBackground,
  PaginationNumberedUnselectedBackgroundDisabled: PaginationNumberedUnselectedBackgroundDisabled,
  PaginationNumberedUnselectedBackgroundHovered: PaginationNumberedUnselectedBackgroundHovered,
  PaginationNumberedUnselectedBackgroundPressed: PaginationNumberedUnselectedBackgroundPressed,
  PaginationNumberedUnselectedBorder: PaginationNumberedUnselectedBorder,
  PaginationNumberedUnselectedBorderDisabled: PaginationNumberedUnselectedBorderDisabled,
  PaginationNumberedUnselectedBorderHovered: PaginationNumberedUnselectedBorderHovered,
  PaginationNumberedUnselectedBorderPressed: PaginationNumberedUnselectedBorderPressed,
  PaginationSelectedPrimary: PaginationSelectedPrimary,
  SwitchBackgroundOn: SwitchBackgroundOn,
  SwitchBorderOn: SwitchBorderOn,
  TableHeaderCellBackground: TableHeaderCellBackground,
  TextAccentedPrimary: TextAccentedPrimary,
  TextAccentedSecondary: TextAccentedSecondary,
  TextAction: TextAction,
  TextCallout: TextCallout,
  TextLink: TextLink,
  TextSecondaryOnDark: TextSecondaryOnDark,
  TextSelected: TextSelected,
  ToggleBackgroundOn: ToggleBackgroundOn,
  ToggleBorderOff: ToggleBorderOff,
  ToggleBorderOffDisabled: ToggleBorderOffDisabled,
  ToggleBorderOn: ToggleBorderOn
};

export { BorderFocus, BreadcrumbText, BreadcrumbTextDisabled, BreadcrumbTextHovered, BreadcrumbTextPressed, ButtonFlatPrimaryForeground, ButtonFlatPrimaryForegroundHovered, ButtonFlatPrimaryForegroundPressed, ButtonFloatingToggleGroupBackgroundColorOff, ButtonLinkForeground, ButtonLinkForegroundHovered, ButtonLinkForegroundPressed, ButtonPrimaryBackground, ButtonPrimaryBackgroundHovered, ButtonPrimaryBackgroundPressed, ButtonSecondaryBackground, ButtonSecondaryBackgroundHovered, ButtonSecondaryBackgroundPressed, ButtonSecondaryForeground, ButtonSecondaryForegroundHovered, ButtonSecondaryForegroundPressed, ButtonTabForegroundOnDefault, ButtonTabForegroundOnHovered, ButtonTabForegroundOnPressed, ButtonTertiaryToggleBackground, ButtonTertiaryToggleBackgroundDisabled, ButtonTertiaryToggleBackgroundHovered, ButtonTertiaryToggleBackgroundOff, ButtonTertiaryToggleBackgroundOffDisabled, ButtonTertiaryToggleBackgroundOffHovered, ButtonTertiaryToggleBackgroundOffPressed, ButtonTertiaryToggleBackgroundPressed, ButtonTertiaryToggleBorderOff, ButtonTertiaryToggleBorderOffDisabled, ButtonTertiaryToggleBorderOffHovered, ButtonTertiaryToggleBorderOffPressed, ButtonTertiaryToggleBorderOn, ButtonTertiaryToggleBorderOnDisabled, ButtonTertiaryToggleBorderOnHovered, ButtonTertiaryToggleBorderOnPressed, ButtonTertiaryToggleForeground, ButtonTertiaryToggleForegroundHovered, ButtonTertiaryToggleForegroundOff, ButtonTertiaryToggleForegroundOffDisabled, ButtonTertiaryToggleForegroundOffHovered, ButtonTertiaryToggleForegroundOffPressed, ButtonTertiaryToggleForegroundPressed, ButtonTertiaryToggleGroupBackgroundOff, ButtonTertiaryToggleGroupBackgroundOffDisabled, ButtonTertiaryToggleGroupBackgroundOffHovered, ButtonTertiaryToggleGroupBackgroundOffPressed, ButtonTertiaryToggleGroupBackgroundOn, ButtonTertiaryToggleGroupBackgroundOnDisabled, ButtonTertiaryToggleGroupBackgroundOnHovered, ButtonTertiaryToggleGroupBackgroundOnPressed, ButtonTertiaryToggleGroupBorderOff, ButtonTertiaryToggleGroupBorderOffDisabled, ButtonTertiaryToggleGroupBorderOffHovered, ButtonTertiaryToggleGroupBorderOffPressed, ButtonTertiaryToggleGroupBorderOn, ButtonTertiaryToggleGroupBorderOnDisabled, ButtonTertiaryToggleGroupBorderOnHovered, ButtonTertiaryToggleGroupBorderOnPressed, ButtonTertiaryToggleGroupForegroundOff, ButtonTertiaryToggleGroupForegroundOffDisabled, ButtonTertiaryToggleGroupForegroundOffHovered, ButtonTertiaryToggleGroupForegroundOffPressed, ButtonTertiaryToggleGroupForegroundOn, ButtonTertiaryToggleGroupForegroundOnDisabled, ButtonTertiaryToggleGroupForegroundOnHovered, ButtonTertiaryToggleGroupForegroundOnPressed, ColorSemanticsAll, DatePickerDateSelectedBackground, DatePickerDateSelectedBackgroundHovered, DatePickerDateSelectedBackgroundPressed, DatePickerDateSelectedIndicatorPrimary, DatePickerDateUnselectedIndicatorPrimary, DatePickerRangeSelectedBackground, DatePickerRangeSelectedBackgroundHovered, DatePickerRangeSelectedBackgroundPressed, DatePickerRangeSelectedIndicatorPrimary, DatePickerTodayBorderSelected, FieldsBackgroundActive, FieldsBackgroundInactive, FieldsBorderActive, FieldsBorderInactive, ListCellIconToggledOff, ListCellIconToggledOn, LoadingDefault, PaginationNumberedNavigationBackground, PaginationNumberedNavigationBackgroundDisabled, PaginationNumberedNavigationBorder, PaginationNumberedNavigationBorderDisabled, PaginationNumberedNavigationForeground, PaginationNumberedSelectedBackground, PaginationNumberedSelectedBackgroundDisabled, PaginationNumberedSelectedBackgroundHovered, PaginationNumberedSelectedBackgroundPressed, PaginationNumberedSelectedBorder, PaginationNumberedSelectedBorderDisabled, PaginationNumberedSelectedBorderHovered, PaginationNumberedSelectedBorderPressed, PaginationNumberedSelectedForeground, PaginationNumberedSelectedForegroundDisabled, PaginationNumberedSelectedForegroundHovered, PaginationNumberedSelectedForegroundPressed, PaginationNumberedUnselectedBackground, PaginationNumberedUnselectedBackgroundDisabled, PaginationNumberedUnselectedBackgroundHovered, PaginationNumberedUnselectedBackgroundPressed, PaginationNumberedUnselectedBorder, PaginationNumberedUnselectedBorderDisabled, PaginationNumberedUnselectedBorderHovered, PaginationNumberedUnselectedBorderPressed, PaginationSelectedPrimary, SwitchBackgroundOn, SwitchBorderOn, TableHeaderCellBackground, TextAccentedPrimary, TextAccentedSecondary, TextAction, TextCallout, TextLink, TextSecondaryOnDark, TextSelected, ToggleBackgroundOn, ToggleBorderOff, ToggleBorderOffDisabled, ToggleBorderOn, ColorSemanticsAll as default };
